<template>
  <div class="new-password">
    <PasswordInput
      :inputHasError="inputError || formError"
      :inputLabel="inputLabel"
      :passwordErrorMessage="strengthField ? '' : newPasswordErrorMessage"
      v-model="newPassword"
      @input="handleInput"
    />

    <PasswordStrengthField
      v-if="strengthField"
      :password="inputPassword"
      :minPasswordLength="passwordMinLength"
      :maxPasswordLength="passwordMaxLength"
      @password-status="handlePasswordStatus" />
  </div>
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import Tooltip from "commons/js/components/atoms/Tooltip.vue";
import PasswordInput from "commons/js/components/atoms/PasswordInput.vue";
import PasswordStrengthField from "commons/js/components/atoms/PasswordStrengthField.vue";

export default {
  components: {
    Tooltip,
    PasswordInput,
    PasswordStrengthField,
  },

  props: {
    formError: {
      type: Boolean,
    },

    inputLabel: {
      type: String,
      required: true
    },

    newPasswordErrorMessage: {
      type: String,
      default: ''
    },

    strengthField: Boolean
  },

  data() {
    return {
      newPassword: "",
      inputPassword: "",
      isPasswordVisible: false,
      passwordMinLength: 12,
      passwordMaxLength: 64,
      passwordGoodStrength: false
    };
  },

  computed: {
    inputError() {
      if (this.newPassword !== "") {
        return this.$v.$invalid || !this.passwordGoodStrength;
      }
    },
  },

  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },

    handleInput() {
      this.$v.newPassword.$touch()
      this.$nextTick(() => {
        this.$emit('input', this.newPassword);
        this.inputPassword = this.newPassword;
      })
    },

    touch() {
      this.$v.newPassword.$touch()
    },

    handlePasswordStatus(boolean) {
      this.passwordGoodStrength = boolean;
    }
  },

  validations() {
    return {
      newPassword: {
        required,
        minLength: minLength(this.passwordMinLength),
        maxLength: maxLength(this.passwordMaxLength),
      },
    };
  },
};
</script>
